module.exports = __webpack_public_path__ + "img/personal_invite_icon_wechat.1768119790257.png";